@if (isAppLoading) {
	<div class="app-bootstrap-screen" role="status" aria-live="polite" aria-busy="true">
		<div class="app-bootstrap-card">
			<div class="app-bootstrap-spinner"></div>
			<div class="app-bootstrap-title">Inicializando autenticação</div>
			<div class="app-bootstrap-text">Carregando permissões e contexto do usuário...</div>
		</div>
	</div>
}

@if (isAppReady) {
	<app-header></app-header>

	<main id="home-content">
		<p-toast position="top-right" styleClass="toast-msg"></p-toast>
		<div class="app-content-shell">
			<router-outlet></router-outlet>
		</div>
	</main>

	<app-footer></app-footer>
}